{
  "sessionID": "d8i3o907tc74b5gqqyp2",
  "adBlockDetection": true,
  "versionRelease": {
    "portal": "90"
  }
}
